/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';
import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import uuid from 'react-uuid';

import { apiConfig } from '@pages/HoldersDetailPage/config/api.config';
import { UPDATE_KYC_STATUS } from '@pages/HoldersDetailPage/api/graphql';

export interface IcreateDeathEventPluginMethods extends IPluginMethodMap {
  getcreateDeathEvent(args?: any): Promise<any>;
}

export class createDeathEventPlugin implements IAgentPlugin {
  readonly methods: IcreateDeathEventPluginMethods;

  constructor() {
    this.methods = {
      getcreateDeathEvent: this.getcreateDeathEvent.bind(this),
    };
  }

  async getcreateDeathEvent(args?: any) {
    console.log("args",args)
    try {
      let sttp = Sttp.withBaseUrl("https://poc-api-capgemini.klefki.io.klefki.io/");
      const res = await sttp.post("scooby-rest/event/occurrence", {
        "eventId": uuid(),
        "aadharNo": args?.aadharNo,
        "dateOfDeath": args?.dod,
        "causeOfDeath": args?.cause,
        "deathCertificate": args?.deathCertificate,
        "status": "ACTIVE",
      });
      if (res?.isError()) {
        log.error(
          `error in post status=${res.status()} statusText=${res.statusText()}`
        );
      }
      return res.data();
    } catch (err: any) {
      log.error('error in post=', err?.message);
      throw Error(err?.response?.data?.error?.display_message);
    }
  }


  // private formatProducts(products: any) {
  //   return products.map((product: any) => product);
  // }
}
